import type { ImageProps } from 'antd'
import React, { useState } from 'react'
import { Image } from 'antd'
import { EyeOutlined } from '@ant-design/icons'
import { EasyModal, EasyImg, FormPage } from 'src/components'
import { mainStore } from 'enasops/stores'
import { getImgBase } from 'src/utils/axios'
import { getSingleRule } from 'src/utils/common'
import 'enasops/styles/op/087/index.less'

const ImageItem = (props: ImageProps) => {
  return <Image {...props} preview={{ mask: <EyeOutlined /> }} />
}

const ImageView = (props: { imgs: string[] }) => {
  const [visible, setVisible] = useState(false)

  return (
    <div className='op087__imgview'>
      {
        props.imgs.length
          ? (
            <React.Fragment>
              <Image.PreviewGroup
                preview={{ visible: visible, onVisibleChange: setVisible }}
                items={props.imgs}
              >
                <ImageItem width={32} height={32} src={props.imgs[0]} />
              </Image.PreviewGroup>
              <EasyImg
                src={require('enasops/assets/op/101/search.png')}
                onClick={() => setVisible(true)}
                className='image-view'
              />
            </React.Fragment>
          )
          : <div className='text-left'>-</div>
      }
    </div>
  )
}

export default {
  renderImg (text: any, record: any, ListTableContext: any) {
    const imgs = JSON.parse(text ?? '[]').filter((img: any) => img.FilePath).map((img: any) => `${mainStore.baseConfig.FileDomain || getImgBase()}${img.FilePath}`)
    return <ImageView imgs={imgs} />
  },
  renderAttrCount (text: any, record: any, ListTableContext: any) {
    const formData = { filterGroup: { Rules: [getSingleRule('EQUIPMENT_ID', 1, record.ID)] } }
    return (
      <div className='display-flex flex-rowfsc'>
        <span className='op087__listtext'>{text}</span>
        <EasyModal
          modal={{ title: '设备查看属性', width: '80%' }}
          slot={<EasyImg src={require('enasops/assets/op/101/search.png')} className='op087__listimg' />}
          slotStyle={{ fontSize: 0 }}
        >
          <FormPage formCode='OP098' formData={formData} />
        </EasyModal>
      </div>
    )
  },
}